import { render, staticRenderFns } from "./AddAssets.vue?vue&type=template&id=10f52726"
import script from "./AddAssets.vue?vue&type=script&lang=js"
export * from "./AddAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports